function validateURLInput(url) {
  return URL.canParse(url);
}

document.addEventListener('trix-initialize', () => {
  // Get the button to open the image link dialog
  const insertImageButton = document.querySelector('#insert-image-link');
  // Add a click event to trigger the dialog
  insertImageButton?.addEventListener('click', (event) => {
    event.preventDefault();

    insertImageButton.classList.add('trix-active');

    // Trigger the custom dialog
    const dialog = document.querySelector<HTMLElement>(
      '.trix-dialog[data-trix-dialog="image_href"]'
    );
    if (dialog) {
      dialog.setAttribute('data-trix-active', 'true');
      const input = dialog.querySelector<HTMLInputElement>(
        'input[name="image_href"]'
      );
      input?.removeAttribute('disabled');
      input?.focus();
    }
  });

  // Handle inserting the image from the dialog
  document
    .querySelectorAll<HTMLButtonElement>('.trix-image-href-button')
    .forEach((button) => {
      button.addEventListener('click', (event) => {
        const method = (event.target as HTMLElement).getAttribute(
          'data-trix-method'
        );
        const dialog = document.querySelector<HTMLElement>(
          '.trix-dialog[data-trix-dialog="image_href"]'
        );
        if (!dialog) return;
        const urlInput = dialog.querySelector<HTMLInputElement>(
          'input[name="image_href"]'
        );
        if (!urlInput) return;
        if (validateURLInput(urlInput.value) === false) {
          urlInput.classList.add('trix-validate');
          urlInput.setAttribute('data-trix-validate', 'true');
          return;
        }

        urlInput.classList.remove('trix-validate');
        urlInput.removeAttribute('data-trix-validate');

        if (method === 'setAttribute' && urlInput.value) {
          const editor =
            document.querySelector<TrixEditorElement>('trix-editor')!;
          editor.editor.insertHTML(
            `<a href="${urlInput.value}" target="_blank"><img src="${urlInput.value}" alt="Image" /></a>`
          );
        }

        // Hide the dialog after inserting or canceling
        dialog.classList.remove('trix-active');
        dialog.removeAttribute('data-trix-active');
        urlInput.value = '';
      });
    });
});
